export default "Gå på opdagelse i opskyllet efter fund fra havets dyb! Hvilke spændende fund gør I mon?";